var React = require('react');

function TableTennis (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M496.28 296.48c31.5-77.81 15.8-170.31-47.2-233.4-83.9-84.1-220-84.1-303.9 0l-56 56.09 211.5 211.5c46.1-62.09 131.5-77.4 195.6-34.19zM416.08 320a96 96 0 1 0 96 96 96 96 0 0 0-96-96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M5.78 452.77a19.7 19.7 0 0 1 1-28.8l103-89.39L75.28 300c-39-39.09-44.6-98.79-17.3-144.09l220.4 220.29c-3.7 12.71-6.3 25.91-6.2 39.71a142.53 142.53 0 0 0 11 55.09c-25.7-2.8-50.6-13.59-70.3-33.3l-35.7-35.7-89.3 103.3a19.59 19.59 0 0 1-28.7 1z","className":"fa-primary","key":2})]);
}

TableTennis.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = TableTennis;

TableTennis.default = TableTennis;
